'use client';

import { Box, Typography, useTheme } from '@mui/material';

import { ComponentBlocksMetricHighlight } from '@/types';

type MetricSidebarProps = {
  block: ComponentBlocksMetricHighlight;
  fixedSidebar?: boolean;
};

export function MetricSidebar({ block, fixedSidebar = false }: MetricSidebarProps) {
  const { MetricHighlightTitle, MetricHighlightInfo } = block;
  const theme = useTheme();

  return (
    <Box
      component="aside"
      sx={(theme) => ({
        borderRadius: 3,
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.divider}`,
        p: fixedSidebar ? { xs: 2, md: 2.5 } : { xs: 3, md: 3.5 },
      })}
    >
      {MetricHighlightTitle && (
        <Typography variant="h6" fontWeight={700} gutterBottom sx={{ textAlign: 'center' }}>
          {MetricHighlightTitle}
        </Typography>
      )}

      {MetricHighlightInfo?.map(
        (item, idx) =>
          item && (
            <Box
              key={idx}
              sx={{
                background: theme.palette.purple[200],
                borderRadius: 2,
                p: 2,
                textAlign: 'center',
                mb: 2,
                '&:last-child': { mb: 0 },
              }}
            >
              {item.MetricDescription && (
                <Typography variant="body2" sx={{ mb: 0.5, color: 'text.secondary' }}>
                  {item.MetricDescription}
                </Typography>
              )}
              {item.MetricInfo && (
                <Typography variant="h6" fontWeight={700} sx={{ fontSize: { xs: 18, md: 20 } }}>
                  {item.MetricInfo}
                </Typography>
              )}
            </Box>
          )
      )}
    </Box>
  );
}
